import React, { useState } from "react";
import {
  Dialog,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { ReactComponent as Dropdown } from "../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as Close } from "../../../assets/images/teamclose.svg";
import { ReactComponent as Calendar } from "../../../assets/images/calendar.svg";
import Input from "../../common/InputField";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// ✅ external CSS

const AddExportDataPopUp = ({ open, onClose }) => {
  const [exportType, setExportType] = useState("");
  const [format, setFormat] = useState("");
  const [email, setEmail] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleExport = () => {
    console.log({
      exportType,
      startDate: startDate ? startDate.format("MM/DD/YYYY") : null,
      endDate: endDate ? endDate.format("MM/DD/YYYY") : null,
      format,
      email,
    });
    onClose();
  };

  return (
    <Dialog
      className="overlay exportDialog"
      open={open}
      onClose={onClose}
    >
      {/* Header */}
      <div className="Team-PopUp-Header">
        <p className="PopUp-Text01">Create New Export</p>
        <p className="PopUp-Text02" onClick={onClose}>
          <Close />
        </p>
      </div>

      <p className="PopUp-Review-Text">
        Configure your data export settings and submit a new request.
      </p>

      {/* Export Type */}
      <Box className="Spacing-Bottom exportType-box">
        <Typography className="input-div">Export Type</Typography>
        <FormControl size="small">
          <Select
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
            IconComponent={Dropdown}
            displayEmpty
            renderValue={(selected) =>
              !selected ? (
                <Typography className="select-placeholder">
                  Select data type of export
                </Typography>
              ) : (
                selected
              )
            }
            className="custom-select"
            MenuProps={{
              PaperProps: { className: "custom-menu" },
            }}
          >
            <MenuItem value="Chats">Chats</MenuItem>
            <MenuItem value="Tickets">Tickets</MenuItem>
            <MenuItem value="Visitors">Visitors</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Date Range */}
      <Box className="Spacing-Bottom">
        <Typography className="input-div">Date Range</Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box className="dateRange-wrapper">
            {/* Start Date */}
            <Box className="dateBox">
              {!startDate && <Box sx={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 14,
                color: '#405261',
                fontFamily: 'Inter',
                fontWeight: 400,
                pointerEvents: 'none',
                zIndex: 1,
                display: startDate ? 'none' : 'block',
              }}>Start Date</Box>}
              <DesktopDatePicker
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                format="MM/DD/YYYY"
                slots={{ openPickerIcon: () => <Calendar /> }}
                slotProps={{
                  disablePortal: true,
                  textField: {
                    size: "small",
                    onFocus: (e) => {
                      if (!startDate) {
                        e.target.blur();
                        e.target.parentElement.parentElement.querySelector('button').click();
                      }
                    },
                    sx: {
                      width: 176,
                      "& .MuiInputBase-root": {
                        height: 40,
                        fontSize: 14,
                        color: "#405261",
                      },
                      "& .MuiInputBase-input": {
                        padding: "0px 12px",
                        fontSize: 14,
                        fontFamily: "Inter",
                        fontWeight: 400,
                        caretColor: startDate ? 'auto' : 'transparent',
                        color: startDate ? '#405261' : 'transparent',
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        border: "1px solid #D5DCE1",
                        borderRadius: 1,
                        mt: 0.5,
                      },
                      "& .MuiPickersDay-root": {
                        fontSize: 14,
                        color: "#556575",
                        "&:hover": {
                          backgroundColor: "#F9FAFA",
                        },
                        "&.Mui-selected": {
                          color: "#061522",
                          backgroundColor: "#F9FAFA !important",
                          "&:hover": {
                            backgroundColor: "#F9FAFA !important",
                          },
                        },
                      },
                    },
                  },
                }}
              />
            </Box>

            {/* End Date */}
            <Box className="dateBox">
              {!endDate && <Box sx={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 14,
                color: '#405261',
                fontFamily: 'Inter',
                fontWeight: 400,
                pointerEvents: 'none',
                zIndex: 1,
                display: endDate ? 'none' : 'block',
              }}>End Date</Box>}
              <DesktopDatePicker
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                minDate={startDate}
                format="MM/DD/YYYY"
                slots={{ openPickerIcon: () => <Calendar /> }}
                slotProps={{
                  disablePortal: true,
                  textField: {
                    size: "small",
                    onFocus: (e) => {
                      if (!endDate) {
                        e.target.blur();
                        e.target.parentElement.parentElement.querySelector('button').click();
                      }
                    },
                    sx: {
                      width: 176,
                      "& .MuiInputBase-root": {
                        height: 40,
                        fontSize: 14,
                        color: "#405261",
                      },
                      "& .MuiInputBase-input": {
                        padding: "0px 12px",
                        fontSize: 14,
                        fontFamily: "Inter",
                        fontWeight: 400,
                        caretColor: endDate ? 'auto' : 'transparent',
                        color: endDate ? '#405261' : 'transparent',
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        border: "1px solid #D5DCE1",
                        borderRadius: 1,
                        mt: 0.5,
                      },
                      "& .MuiPickersDay-root": {
                        fontSize: 14,
                        color: "#556575",
                        "&:hover": {
                          backgroundColor: "#F9FAFA",
                        },
                        "&.Mui-selected": {
                          color: "#061522",
                          backgroundColor: "#F9FAFA !important",
                          "&:hover": {
                            backgroundColor: "#F9FAFA !important",
                          },
                        },
                      },
                    },
                  },
                }}
              />
            </Box>
          </Box>
        </LocalizationProvider>
      </Box>

      {/* Format */}
      <Box className="Spacing-Bottom">
        <Typography className="input-div">Format</Typography>
        <FormControl size="small">
          <Select
            value={format}
            onChange={(e) => setFormat(e.target.value)}
            IconComponent={Dropdown}
            displayEmpty
            renderValue={(selected) =>
              !selected ? (
                <Typography className="select-placeholder">
                  Select an Option
                </Typography>
              ) : (
                selected
              )
            }
            className="custom-select"
            MenuProps={{
              PaperProps: { className: "custom-menu" },
            }}
          >
            <MenuItem value="CSV">CSV</MenuItem>
            <MenuItem value="JSON">JSON</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Recipient Email */}
      <Input
        title="Recipient Email"
        placeholder="Enter email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      {/* Footer */}
      <div className="exportBtn-footer">
        <button className="SendChat-Button exportBtn" onClick={onClose} type="button">
          Cancel
        </button>
        <button disabled={
          !exportType || !startDate || !endDate || !format || !email
        } className="SendChat-Button01 exportBtn" onClick={handleExport} type="button">
          Export
        </button>
      </div>
    </Dialog>
  );
};

export default AddExportDataPopUp;
